import { render } from "./RedeemProfileAccessLink.vue?vue&type=template&id=4387b6ae&scoped=true"
import script from "./RedeemProfileAccessLink.vue?vue&type=script&lang=js"
export * from "./RedeemProfileAccessLink.vue?vue&type=script&lang=js"

import "./RedeemProfileAccessLink.vue?vue&type=style&index=0&id=4387b6ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4387b6ae"]])

export default __exports__